module.exports    = {
	"speakers": [
		{
			"id": "taisukef",
			"name": "福野 泰介",
			"furi": "ふくの たいすけ",
			"title": "こどもシビックテックとオープンデータ x IoT",
			"description": "オープンデータ法を成立させ、世界最先端IT国家を創造すると宣言した日本。\nオープンデータ都市は日本46都道府県262都市に広がるも、まだ応用例は少ないブルーオーシャン。\n今までの常識が通じないからこそ、異業種、異世代が一緒に取り組むシビックテックがおもしろい！\n鯖江で始まる次年度こどもプログラミング教育と、こどもIoTハッカソンによるスタートアップ創出に向けた取り組みを紹介します。\n",
			"profile": "# 略歴\n1978年11月8日石川県生まれ。国立福井工業高等専門学校電子情報工学科を卒業後、2000年に有限会社シャフトを設立しCTOに就任。2001年に有限会社ユーエヌアイ研究所を設立、代表取締役社長に就任。2003年5月に株式会社jig.jpを設立し代表取締役社長に就任（現任）。\n2016年に内閣官房情報通信技術（IT）総合戦略室が任命する「オープンデータ伝道師（8名）」のひとり\n\n# 紹介\n小学3年生の時、何度でも作り直せるプログラミングの世界に出会い、開発言語をBASIC、アセンブラ、C言語と変えながらソフト作りに熱中する。福井高専に在学中、研究会やアルバイトでソフト開発に携わり、自分が開発したものを人に使ってもらう喜びを知る。卒業後、フリープログラマーをしながら起業を考える。2つの会社の創業を経て、現在の株式会社jig.jpを設立。当時モバイルサイトしか見られなかった携帯電話向けに、パソコン用サイトを閲覧可能とする世界初のダウンロード型のフルブラウザ『jigブラウザ』を開発。より豊かな社会のモデルを探るため、本店があり、在住している福井県鯖江市で、こどもやシニア向けのプログラミング講座、自治体オープンデータ「データシティ鯖江」とそれを活用する団体「Code for Sabae」、首都圏の起業家と交流するITイベントなどを手がけている。また、高専生の更なる活躍に期待しており、全国の高専からのインターン受け入れや講演会、「Code for KOSEN」などを通じて、後輩のバックアップに取り組んでいる。\n",
			"image": "/img/2017_fukuno@2x.jpg",
			"github": "taisukef",
			"twitter": "taisukef",
			"facebook": "taisuke.fukuno",
			"tags": [
				"IoT",
				"シビックテック",
				"オープンデータ"
			],
			"links": [
				{
					"name": "福野泰介の一日一創",
					"href": "http://fukuno.jig.jp"
				}
			]
		},
		{
			"id": "yamamoto_manabu",
			"name": "山本 学",
			"furi": "やまもと まなぶ",
			"title": "myThingsからみたIoTの可能性",
			"description": "2015年7月に「すべて」をつなげるというコンセプトでmyThingsというサービスをリリースしました。\n「すべて」の中にはWebや企業、人、街、データ、そして昨今すさまじい勢いで進化しているIoTデバイスも含みます。\n今回はそのmyThingsを設計・開発・運用していく中でみえてきたIoTの可能性についてお話できればと思います。\n",
			"profile": "# 略歴\nヤフー株式会社所属のエンジニア。ヤフーではYahoo!クラウドソーシングの基盤設計・開発、スクラムマスターを担当した後、IoT領域の新サービスであるmyThingsでもスクラムマスターとして開発に従事した。myThingsリリース後は、myThingsの魅力をより多くのエンドユーザー、開発者に伝えるべくmyThingsのエバンジェリストとして活動を行っている。好きな言葉は自動化、見える化、見せる化。\n",
			"tags": [
				"myThings"
			],
			"image": "/img/2017_yamamoto@2x.jpg",
			"twitter": "yamamoto_manabu",
			"facebook": "yamamoto.manabu.gak",
			"oraganizatinos": [
				{
					"name": "ヤフー株式会社　スマートデバイス推進本部　大阪開発室",
					"href": "http://docs.yahoo.co.jp/"
				}
			],
			"links": [
				{
					"name": "Software Design 2016年5月号　SORACOM特集　「＜特別SIMで始めよう！　SORACOMでわかるIoT＞　第4章：myThingsとSORACOM\n―― myThingsを使ってノンプログラミングでSORACOMをより便利に使おう」",
					"href": "http://gihyo.jp/magazine/SD/archive/2016/201605"
				}
			],
			"sessions": [
				{
					"name": "デブサミ2016　「myThingsからみたIoTの未来と課題」",
					"href": "http://event.shoeisha.jp/devsumi/20160218/session/983/"
				}
			]
		},
		{
			"id": "yoshioterada",
			"name": "寺田 佳央",
			"furi": "てらだ よしお",
			"title": "Engineer is Hero !! \\\nマイクロサービスの開発手法や IoT を採用し感情や表情を解析しより良い社会を作ろう\n",
			"description": "Microsoft の Cognitive Services を利用すると、写真のデータを解析し人間の性別や年齢、感情などを推測することができます。本セッションでは Cognitive Services のアプリケーション開発から、IoT を利用したデモでご覧いただくほか、マイクロサービスを活用した開発手法の注意点についてご紹介します。",
			"profile": "2001 年 サン・マイクロシステムズ株式会社に入社し GlassFish エバンジェリストとして活動。その後、日本オラクル株式会社で Java エバンジェリストとして活動。\n2015 年 7月、日本マイクロソフト株式会社に移籍し、移籍後もなお Java エバンジェリストとして、マイクロソフト・プラットフォームにおける Java の利用促進・啓蒙活動を実施中。2016 年 7 月、日本人で 2 人目となる Java Champion に就任。\n",
			"tags": [
				"Microsoft",
				"Java",
				"IoT",
				"広島"
			],
			"image": "/img/2017_terada@2x.jpg",
			"twitter": "yoshioterada",
			"facebook": "yoshio.terada",
			"links": [
				{
					"name": "ブログ",
					"href": "https://yoshio3.com/"
				}
			],
			"oraganizatinos": [
				{
					"name": "日本マイクロソフト株式会社",
					"href": "https://www.microsoft.com/ja-jp/"
				},
				{
					"name": "シニア Java エバンジェリスト"
				}
			],
			"sessions": [
				{
					"name": "Microsoft Tech Summit 「Pivotal Cloud Foundry on Azure で実現する Java マイクロサービス開発のご紹介」",
					"href": "http://microsoft-events.jp/mstechsummit/session/"
				},
				{
					"name": "Java One 2015 San Francisco「Building Nanoservices with Java EE and Java 8」",
					"href": "https://events.rainfocus.com/oow15/catalog/oracle.jsp?event=javaone&search=%22Yoshio%20Terada%22&showEnrolled=false"
				},
				{
					"name": "Java Day Tokyo 2015 「Java EE 7エッセンシャルレシピ」",
					"href": "http://www.slideshare.net/OracleMiddleJP/cdi-essential-receipe-at-java-day-tokyo-2015"
				},
				{
					"name": "Developers Summit 2016 「そろそろ俺たちの本気を見せてやるぜ！～ マイクロソフトとOSSごった煮 DevOps 衝撃デモシリーズ！」",
					"href": "http://event.shoeisha.jp/devsumi/20160218/"
				}
			]
		},
		{
			"id": "motoki",
			"name": "元木 昭宏",
			"furi": "もとき あきひろ",
			"title": "ワクワクエンジニアライフの提案",
			"description": "広島と言えばモノづくり。IoTやシェリングエコノミーの出現により、行く末が不透明になってきています。コトづくりへのシフトに備える必要性を、クルマを事例に紹介します。ICTエンジニアがそのシフトに対する救世主となり、ワクワクする広島であり続けるため、そして自身もワクワクするエンジニアライフを過ごすために、広島のICTコミュニティのあるべき姿を提案します。",
			"image": "/img/2017_motoki@2x.jpg",
			"profile": "2015年8月、ハッカソンという単語も知らずにハッカソンに参加し、ICTをツールとしたオープンイノベーションに目覚める。\n以来、アイデアソン／ハッカソンのみならず各種イベントに参加することでICTコミュニティを作りながら、広島の存在感増幅を目指して活動中。\nまた、17年間楽しんでいるサイクリングについても、ICTのチカラを借りてイノベーションを起こす事を企み中。\n",
			"facebook": "akihiro.motoki.5",
			"tags": [
				"ICT",
				"コミュニティ",
				"ミドル",
				"広島"
			],
			"oraganizatinos": [
				{
					"name": "NPO法人 瀬戸内サイクルメディア",
					"href": "http://npo-scm.wixsite.com/setouchi"
				},
				{
					"name": "一般社団法人 HMCN（Hiroshima Motion Control Network）",
					"href": "https://hmcn.doorkeeper.jp/"
				},
				{
					"name": "マツダ株式会社コネクティビティ企画"
				}
			],
			"links": [
				{
					"name": "ミドル×IT　50代からのスマホアプリ開発 @IT",
					"href": "http://www.atmarkit.co.jp/ait/articles/1606/08/news009.html"
				}
			],
			"sessions": [
				{
					"name": "次世代自動車ビジネス研究会 「コネクティビティーによる顧客体験の変革」",
					"href": "http://techon.nikkeibp.co.jp/at/cp/16/car2025/"
				},
				{
					"name": "KDDI∞Labo2015",
					"href": "https://www.pref.hiroshima.lg.jp/site/innovation/kddi1216.html",
					"facebook": "akihiro.motoki.5"
				}
			]
		},
		{
			"id": "hanatani",
			"name": "花谷 美香",
			"furi": "はなたに みか",
			"title": "子どもプログラミングとドリームマップ",
			"description": "\"\n子どもたちの個性を伸ばし、夢を叶えることを応援する活動の中で子どもプログラミング教室を開講して１年が経ちました。\nITが一般的になった社会では、プログラミングができるかどうかで大きな差がついてしまいます。\nプログラマの皆さんは、プログラミングを通して、論理的思考力と物事の仕組みへの探求心を育まれてこられたことと思います。\nこれらの能力によって子どもたちが夢に大きく近づくことができると思います。\n今回は、子どもプログラミング教室を開校して見えてきたことと、そこから得られたことから、現役プログラマさんにお伝えしたいことをお話したいと思います。\n",
			"profile": "電機メーカー勤務を経てパソコンインストラクターになり、県内私立大学や専門学校の非常勤講師、企業研修、その他官・民主催のパソコン講習の講師となる。\n2016年3月より子どもプログラミング教室　Dream Tech Schoolを開校\n現在　牛田、古田台、光明学園、舟入、宇品、広島YMCA学園の６教室で展開中。\nまた、光明学園、YMCA国際幼児園、なぎさ公園小学校にプログラミング授業を企画・提案し、実施することにより、子どもたちのより良い未来のために奮闘するかたわら、一般社団法人ドリームマップ普及協会の認定ドリマ講師として、小・中・高等学校等でドリームマップ授業を実施中。\n",
			"image": "/img/2017_hanatani@2x.jpg",
			"tags": [
				"子どもプログラミング",
				"広島"
			],
			"oraganizatinos": [
				{
					"name": "株式会社ハッピーちゃい夢 代表取締役",
					"href": "http://www.dream-tech.jp/company/"
				}
			]
		},
		{
			"id": "yayuyayu",
			"name": "薬師神 裕樹",
			"furi": "やくしじん ゆうき",
			"title": "生活の中のテクノロジーとサービスとUXについて",
			"description": "私達の生活はサービスとテクノロジーに支えれ、それらの集合体で成り立っています。ただし、私達は普段から、1つひとつの体験をじっくり捉える時間というのはありません。テクノロジーやサービスの提供側と利用者の両方の視点を持ってよりよい生活を目指すというUXの視点を、改めてお話していきます。",
			"image": "/img/2017_yakushijin@2x.jpg",
			"profile": "BIZSTAR株式会社代表。ビジネスコンサルタント。Web制作会社やシステム会社勤務で情報設計やユーザーエクスペリエンスの上流工程に従事。2012年に独立し、2014年BIZSTAR株式会社を設立。\n\nビジネスオーナーの利益に繋げるコンサルティング業務を展開。顧客理解とUXを軸にオンライン／オフライン問わずあらゆる施策をサポートするマーケティング支援を行っています。\n\nUX HIROSHIMA主催。中小企業庁ミラサポ専門家。\n",
			"tags": [
				"UX",
				"広島"
			],
			"twitter": "yayuyayu",
			"facebook": "yuki.yakushijin",
			"oraganizatinos": [
				{
					"name": "BIZSTAR株式会社",
					"href": "https://bizstar.co.jp/"
				},
				{
					"name": "UX HIROSHIMA",
					"href": "http://uxhiroshima.com/"
				}
			],
			"sessions": [
				{
					"name": "CSS Nite in HIROSHIMA, Vol. 7 「広島という市場でプロジェクトを成功させる、IAやディレクションの秘訣」",
					"href": "http://cssnite.webtouchmeeting.com/vol7/"
				},
				{
					"name": "UX JAPAN FORUM 2016 「UXを広島に」",
					"href": "http://www.uxjapan.org/"
				},
				{
					"name": "UXシンポジウム沖縄2015 「ユーザーインサイトに\"ダイブ\"するユーザー理解を深める 「主観的共感」の重要性」",
					"href": "http://7dw.jp/blog/2038"
				}
			]
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/toml-loader!./src/2017/speaker.toml
 ** module id = 149
 ** module chunks = 0
 **/